import { Flex } from '@chakra-ui/react'
import { useAtomValue } from 'jotai'
import { useEffect } from 'react'

import { getNews, getNewsById, newsAtom } from '@/store/news'
import { INewsItem } from '@/types/news'

import LeftNewsSection from './newsUpdates/leftSide/LeftNewsSection'
import RightMoreNewsSection from './newsUpdates/rightSide/RightMoreNewsSection'

export default function NewsRelease() {
    const newsData: INewsItem[] = useAtomValue(newsAtom)
    useEffect(() => {
        getNews(false)
    }, [])

    useEffect(() => {
        newsData && newsData.length > 0 && getNews(true)
    }, [newsData])

    const handleCardClick = (id: string) => {
        getNewsById(id)
    }
    return (
        <Flex
            direction={{ base: 'column', md: 'row' }}
            w="100%"
            p={{ base: 2, md: 4 }}
            gap={6}
            alignItems="flex-start"
            gridTemplateColumns="70% 30%"
            overflowY="auto"
        >
            <LeftNewsSection />
            <RightMoreNewsSection moreNews={newsData} onCardClick={handleCardClick} />
        </Flex>
    )
}
